module.exports = __webpack_public_path__ + "static/media/RedisLogo.8b577cf1.png";